import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { OperatorCompaniesActions } from '../actions/operator-companies.actions';

@Injectable({ providedIn: 'root' })
export class OperatorCompaniesActionsFacade {
  private readonly _store = inject(Store);

  public loadCompanies(): void {
    this._store.dispatch(OperatorCompaniesActions.loadCompanies());
  }

  public resetState(): void {
    this._store.dispatch(OperatorCompaniesActions.resetState());
  }
}
